export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_03.e2a63b2a.jpg";